/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialTagLanguagesResponse } from '../../models/editorial-tag-languages-response';

export interface GetEditorialTagLanguages$Params {
}

export function getEditorialTagLanguages(http: HttpClient, rootUrl: string, params?: GetEditorialTagLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorialTagLanguagesResponse>>> {
  const rb = new RequestBuilder(rootUrl, getEditorialTagLanguages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EditorialTagLanguagesResponse>>;
    })
  );
}

getEditorialTagLanguages.PATH = '/api/editorial/tags-languages';
